import { getLocales } from 'expo-localization';
import { AVAILABLE_LANGUAGES, LANGUAGE_COOKIE } from '../../app/settings';
import jsCookies from 'js-cookie';

function getCookieLanguage(): string | undefined {
  return jsCookies.get(LANGUAGE_COOKIE);
}

function setCookieLanguage(language: string): string | undefined {
  return jsCookies.set(LANGUAGE_COOKIE, language, { expires: 365 });
}

export function getFallbackLanguage(): string {
  return AVAILABLE_LANGUAGES[0];
}

export function getLanguage(): string {
  let language: string | null = null;

  jsCookies.remove(LANGUAGE_COOKIE)

  const cookieLanguage = getCookieLanguage();

  language =
    typeof cookieLanguage !== 'undefined' && AVAILABLE_LANGUAGES.includes(cookieLanguage) ? cookieLanguage : null;

  if (!language) {
    const localeLanguage = getLocales()[0]?.languageCode ?? undefined;
    language =
      typeof localeLanguage !== 'undefined' && AVAILABLE_LANGUAGES.includes(localeLanguage) ? localeLanguage : null;
  }

  if (!language) {
    language = getFallbackLanguage();
  }

  return language;
}
